import type {ListItem} from '@github-ui/markdown-editor/list-editing'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import type {SafeHTMLString} from '@github-ui/safe-html'
import type {TaskItem} from '../constants/types'
import {useMemo} from 'react'
import {sanitizeTaskListContent} from '../utils/sanitize-content'

import styles from './ListItem.module.css'

export type ListItemProps = {
  item: TaskItem
  position: number
}

export function ListItem({item, position}: ListItemProps) {
  const tasklistIstemTestIdBase = `tasklist-item-${position}-${item.markdownIndex}`

  // Memoize the sanitized content to avoid re-sanitizing on every render
  const sanitizedContent = useMemo(() => sanitizeTaskListContent(item.content), [item.content])

  return (
    <VerifiedHTMLDiv
      // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string
      html={sanitizedContent as SafeHTMLString}
      data-testid={tasklistIstemTestIdBase}
      className={styles.ListItemContent}
    />
  )
}
